import React, { useEffect, useRef, useState } from 'react';
import { MAPPING } from '../helpers';

const ToolTip = (props) => {
  const { MSRP, MsrpDisclaimer, baseMSRP, destinationChargePrice } = props;
  const [showToolTip, setShowToolTip] = useState(false);

  const tooltipRef = useRef(null);

  const { closeTooltip, destinationChargeLabel } = MAPPING;

  const toggleVisibility = () => {
    setShowToolTip(!showToolTip);
  };

  const closeToolTip = () => {
    setShowToolTip(false);
  };

  // click outside will close tooltip
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && tooltipRef.current !== event.target && !tooltipRef.current.contains(event.target)) {
        setShowToolTip(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div ref={tooltipRef} className="model-price w-fit mb-9 text-sm leading-normal md:leading-1p2 text-gray-650 tooltip">
      {!MsrpDisclaimer &&
        <span className="cursor-auto">{baseMSRP} <span>{MSRP}</span>*</span>
      }

      {MsrpDisclaimer &&
        <>
          <button type="button" className="text-left" onClick={toggleVisibility}>{baseMSRP} <span className="">{MSRP}</span>*
            {destinationChargePrice &&
              <span className="block">{destinationChargeLabel || 'Destination Charge'} {destinationChargePrice}</span>
            }
          </button>
          <span className={`wrap-tooltip z-99 ${showToolTip ? 'show' : ''}`}>
            <span className="tooltip-card block">
              <button type="button" className="tooltip-close-btn" onClick={closeToolTip}>
                <span className="sr-only">{closeTooltip}</span>
                <span className="icomoon icon-x" aria-hidden="true" />
              </button>
              <span className="tooltip-content block">{MsrpDisclaimer}</span>
            </span>
          </span>
        </>
      }
    </div>
  );
};
export default ToolTip;